import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ children, requiredPermission, requireModule }) => {
  const { isAuthenticated, loading, hasPermission, hasModuleAccess } = useAuth();

  // Mostrar loading mientras se verifica autenticación
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar acceso a módulo si es requerido
  if (requireModule && !hasModuleAccess(requireModule)) {
    return <AccessDenied />;
  }

  // Verificar permiso específico si es requerido
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <AccessDenied />;
  }

  // Si todo está bien, renderizar el componente hijo
  return children;
};

export default ProtectedRoute;
